import { render } from "./BaseModal.vue?vue&type=template&id=5e10ba86&scoped=true&ts=true"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"

import "./BaseModal.vue?vue&type=style&index=0&id=5e10ba86&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e10ba86"]])

export default __exports__